export default "__VITE_ASSET__CTHMHas7__"